import { Navigate, useLocation, useParams } from "react-router-dom";

export default function LegacyApplicationDetailsRedirect() {
  const { applicationId } = useParams();
  const location = useLocation();

  return (
    <Navigate to={`/people/membership-services/applications/${applicationId}/details${location.search}`} replace />
  );
}
